import { IGridColumn } from '@aex/shared/common-lib';

export const getKeyPathFromColumnObject = (column: IGridColumn): string => {
	let keyPath = column.field;
	if (column.sub_field)
		keyPath += `.${column.sub_field}`;

	return keyPath;
};
